import React, { useState } from "react";

// import CustomTable from "../../../../customComponents/CustomTable";
import searchIcon from "../../../../Assets/icons/searchicon.svg";

import "./SaleslistPage.scss";
import CustomTable from "../../../customComponents/CustomTable";
import ListLogisticsFilters from "../../Logistics/LogisticsFilter";
import { IoMdClose } from "react-icons/io";
// import ListLogisticsFilters from "../../../Logistics/LogisticsFilter";

const SalesListPage = ({
  
  searchplaceholder="",
  isButtonRequired = true,
  isFilterRequired= false,
  isAddButtonRequired = true,
  isDownloadRequired = true,
  isUploadButtonRequired,
  headerTopText = "",
  headerTitle = "",
  addButtonTitle = "Add",
  uploadButtonTitle = "Upload",
  listTitle = "",
  topDetailsList = [],
  tableData = [],
  tableHeaders = [],
  keyMapping = {},
  itemsPerPage = 10,
  handleOnAddButton = () => {},
  handleOnUploadButton = () => {},
  handleViewButton = () => {},
  onEdit = () => {},
  onPageChange = () => {},
  currentPage,
  totalPages,
  totalRecords,
  filterInputs,
  handleFormSubmit,
  filterFormData,
  setFilterFormData,
  validationErrors,
  setValidationErrors,
  handleClear,
  searchQuery,
  handleClearSearch=()=>{},
  // setSearchQuery =()=>{},
  handleSearchChange=()=>{},
  fetchDepartments=()=>{},
  setSearchQuery,
  handleKeyPress=()=>{},
  apiCallFunction=()=>{},
  pdfDownLoad=()=>{},
  handleDownloadButton,
  handlePrintInvoice=()=>{}
}) => {
  console.log("tableData",totalRecords);
  
  const [selectedDurationFilter, setSelectedDurationFilter] = useState(null);

  // const durationFilterTabList = [
  //   { id: 1, title: "This Month" },
  //   { id: 2, title: "Last 3 Months" },
  //   { id: 3, title: "Last 6 Months" },
  //   { id: 4, title: "Last Year" },
  // ];
  console.log("totalRecords",totalRecords);
  handleSearchChange = (e) =>{
    setSearchQuery(e.target.value)
  }

return (
    <div className="row">
      <div className="col-12 listTopContainer">
        <div className="col-12 listMainContainer">
          <div className="col-2 listMainTitleContainer">
            <div className="listTitleHead">{headerTopText || ""}</div>
            <h5 className="listTitleText mt-1">{headerTitle || ""}</h5>
          </div>
          <div className="col-7 d-flex justify-content-between listTopCentreDataContainer">
            {topDetailsList?.length > 0 &&
              topDetailsList?.map((details, index) => (
                <>
                  <div
                    key={details?.id || index}
                    className="listTopDataContainer"
                  >
                    <div className="listTopDataValueText">
                      {details?.value || 0}
                    </div>
                    <div>{details?.title || 0}</div>
                  </div>
                  {index + 1 < topDetailsList?.length && (
                    <div className="listSideBorder" />
                  )}
                </>
              ))}
          </div>
          {isButtonRequired && (
            <div className=" d-flex justify-content-around listTopButtonsContainer">
              {isAddButtonRequired && (
                <button
                  className="listAddButtonStyle addFormButton m-2 px-3"
                  onClick={handleOnAddButton}
                >
                  {addButtonTitle || ""}
                </button>
              )}
              {/* {isUploadButtonRequired && (
                <button
                  className="listUploadButtonStyle m-2 py-2 px-3"
                  onClick={handleOnUploadButton}
                >
                  {uploadButtonTitle || ""}
                </button>
              )} */}
            </div>
          )}

          {/* {isButtonRequired && (
            <div className=" d-flex justify-content-end listTopButtonsContainer">
              {isAddButtonRequired && (
                <button
                  className="listAddButtonStyle m-2 py-2 px-3"
                  onClick={handleOnAddButton}
                >
                  {addButtonTitle || ""}
                </button>
              )}
              {isUploadButtonRequired && (
                <button
                  className="listUploadButtonStyle m-2 py-2 px-3"
                  onClick={handleOnUploadButton}
                >
                  {uploadButtonTitle || ""}
                </button>
              )}
            </div>
          )} */}
        </div>
        {/* {durationFilterTabList?.length > 1 && (
          <div className="listTabContainer col-12">
            <div className="col-12 d-flex align-items-center flex-row flex-wrap mb-3">
              {(durationFilterTabList || []).map((tabDetails, index) => (
                <button
                  key={tabDetails?.id || index}
                  className={
                    tabDetails?.id === selectedDurationFilter?.id
                      ? "listDurationActiveTab ms-1 me-1 px-5 py-3"
                      : "listDurationInactiveTab ms-1 me-1 px-5 py-3"
                  }
                  onClick={() => setSelectedDurationFilter(tabDetails)}
                >
                  {tabDetails?.title || ""}
                </button>
              ))}
            </div>
          </div>
        )} */}
        {/* {
          isFilterRequired && (
            <ListLogisticsFilters 
            formConfig={filterInputs} 
            formData={filterFormData}
            setFormData={setFilterFormData}
            validationErrors={validationErrors}
            setValidationErrors={setValidationErrors}
            handleSearch={handleFormSubmit} 
            handleClear={handleClear}
            />
          )
        } */}

        {/* {cardsList?.length > 1 && (
          <div className="listCardContainer col-12">
            <div className="col-12 d-flex align-items-center flex-row flex-wrap mb-3 g-2">
              {(cardsList || []).map((cardDetails, index) => (
                <div
                  key={cardDetails?.id || index}
                  className={`col-${12 / cardsList?.length} px-2`}
                >
                  <div className="listCard">{cardDetails?.title || ""}</div>
                </div>
              ))}
            </div>
          </div>
        )} */}
      </div>

      <div className="listTableContainer mt-2">
        <div className="SaleslistTableTopComponentContainer">
          <div style={{paddingTop:"30px"}} className="listSearchBarContainer">
            <h5>{listTitle || ""} </h5>
            <div className="searchinput-wrapper">
            <input
              type="text"
              className="searchinput"
              placeholder={searchplaceholder}
              value={searchQuery}
              onChange={(e) => {
                handleSearchChange(e); // Update the search query state
              }}
              onKeyPress={handleKeyPress} // Handle the Enter key press separately
            />
              {searchQuery ? (
              <IoMdClose
                size={22}
                className="searchinput-close-icon"
                onClick={handleClearSearch}
              />
            ) : (
              <img src={searchIcon} alt="Search" className="searchinput-icon" />
            )}
            </div>
          </div>

          <div style={{paddingRight:"100px"}}>
          {
          isFilterRequired && (
            <ListLogisticsFilters 
            formConfig={filterInputs} 
            formData={filterFormData}
            setFormData={setFilterFormData}
            validationErrors={validationErrors}
            setValidationErrors={setValidationErrors}
            handleSearch={handleFormSubmit} 
            handleClear={handleClear}
            />
          )
        }
          </div>
  
          

        </div>

        <CustomTable
          data={tableData}
          headers={tableHeaders}
          keyMapping={keyMapping}
          itemsPerPage={itemsPerPage}
          handleViewButton={handleViewButton}

          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={onPageChange}
          onEdit={onEdit} 
          totalRecords={totalRecords} 
          pdfDownLoad={pdfDownLoad}
          handleDownloadButton={handleDownloadButton}

          handlePrintInvoice={handlePrintInvoice}
        />
      </div>
    </div>
  );
};

export default SalesListPage;
